
export type ISlotsListState = {
    name: string;
    id: number;
    slot_type: string
}

export enum ISlotListActionTypes {
    FETCH_SLOTS_LIST_REQUEST = 'FETCH_SLOTS_LIST_REQUEST',
    FETCH_SLOTS_LIST_SUCCESS = 'FETCH_SLOTS_LIST_SUCCESS',
    FETCH_SLOTS_LIST_FAILURE = 'FETCH_SLOTS_LIST_FAILURE',

}

export type ISlotListActionCreator = {
    type: string;
    payload: ISlotsListState;
};
